module.exports = __webpack_public_path__ + "img/preview.01a5054a.png";